let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2DJ8B")).then(() => parcelRequire('a8JgW'));